module.exports = __webpack_public_path__ + "static/media/ecosentino.09b9e60b.png";